// TYPES ---------------------------------------------------------------- //

export interface LatLng {
  lat: number;
  lng: number;
}

// HELPERS ---------------------------------------------------------------- //

/**
 * Midpoint of two points. If only one point is provided, returns that point.
 * If both are null/undefined, returns `{ lat: 0, lng: 0 }`.
 */
export const getMidpointCenter = (a?: LatLng | null, b?: LatLng | null): LatLng => {
  if (a && b) {
    return { lat: (a.lat + b.lat) / 2, lng: (a.lng + b.lng) / 2 };
  }
  return a || b || { lat: 0, lng: 0 };
};

/**
 * Pick a zoom level based on the span between two points. With only one point
 * (or none) returns 15, a city-level default suitable for a single-pin view.
 */
export const getZoomForSpan = (a?: LatLng | null, b?: LatLng | null): number => {
  if (!a || !b) return 15;
  const latDiff = Math.abs(a.lat - b.lat);
  const lngDiff = Math.abs(a.lng - b.lng);
  const maxDiff = Math.max(latDiff, lngDiff);

  if (maxDiff > 0.5) return 10;
  if (maxDiff > 0.2) return 11;
  if (maxDiff > 0.1) return 12;
  if (maxDiff > 0.05) return 13;
  return 14;
};
